"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ThirdPartySubscriptionStatus;
(function (ThirdPartySubscriptionStatus) {
    ThirdPartySubscriptionStatus[ThirdPartySubscriptionStatus["NOT_SUBSCRIBED"] = 0] = "NOT_SUBSCRIBED";
    ThirdPartySubscriptionStatus[ThirdPartySubscriptionStatus["SUBSCRIBED"] = 1] = "SUBSCRIBED";
    ThirdPartySubscriptionStatus[ThirdPartySubscriptionStatus["UNSUBSCRIBED"] = -1] = "UNSUBSCRIBED";
})(ThirdPartySubscriptionStatus = exports.ThirdPartySubscriptionStatus || (exports.ThirdPartySubscriptionStatus = {}));
var ThirdPartySource;
(function (ThirdPartySource) {
    ThirdPartySource[ThirdPartySource["WECHAT_APP"] = 0] = "WECHAT_APP";
    ThirdPartySource[ThirdPartySource["WECHAT_MP"] = 1] = "WECHAT_MP";
    ThirdPartySource[ThirdPartySource["WECHAT_WEAPP"] = 2] = "WECHAT_WEAPP";
    ThirdPartySource[ThirdPartySource["SINA"] = 3] = "SINA";
    ThirdPartySource[ThirdPartySource["QQ"] = 4] = "QQ";
    ThirdPartySource[ThirdPartySource["WECHAT_WORK"] = 1000] = "WECHAT_WORK";
})(ThirdPartySource = exports.ThirdPartySource || (exports.ThirdPartySource = {}));
var AuthScope;
(function (AuthScope) {
    AuthScope["AUTH_USER"] = "auth_user";
    AuthScope["AUTH_BASE"] = "auth_base";
    AuthScope["AUTH_ZHIMA"] = "auth_zhima";
})(AuthScope = exports.AuthScope || (exports.AuthScope = {}));
var GrantType;
(function (GrantType) {
    GrantType["AUTHORIZATION_CODE"] = "authorization_code";
})(GrantType = exports.GrantType || (exports.GrantType = {}));
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/auth.js
// module id = 994
// module chunks = 0